export const GET_WORKSHOPS = "GET_WORKSHOPS";
export const GET_SECTIONS_FOR_IRN = "GET_SECTIONS_FOR_IRN";